import React from 'react';
import { useSelector, connect } from 'react-redux';
import { reset as resetForm } from 'redux-form';
import { reset } from '../../redux/actions/Coberturas';
import Label from '../utils/Label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';



const Summary = ({ resetReservacion, resetDataCliente }) => {
    const reservacion = useSelector(state => state.reservacion)
    const vehiculo = useSelector(state => state.vehiculo)
    const coberturas = useSelector(state => state.coberturas)
    const servicios = useSelector(state => state.servicios)
    const fronteras = useSelector(state => state.fronteras)
    const { Dias } = useSelector(state => state.reservacion)
    const { Cambio } = useSelector(state => state.moneda);

    const handleReset = () => {
        resetReservacion();
        resetDataCliente();
        window.scrollTo(0, 0);
    }
    
    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: "right" }}>
                        <button type="button" data-toggle="tooltip" data-placement="left" title="Eliminar Reservación" className="btn-reset" onClick={() => handleReset()}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="card-title">RESUMEN</h2>
                    </div>
                </div>
                {
                    (reservacion.LugarRecepcion !== undefined) &&
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>RECEPCIÓN DEL VEHÍCULO</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="LUGAR" />
                                        <input type="text" value={reservacion.LugarRecepcion.Direccion} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="FECHA Y HORA" />
                                        <input type="text" value={reservacion.FechaRecepcion} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12" style={{ height: "20px" }}></div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>DEVOLUCIÓN DEL VEHÍCULO</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="LUGAR" />
                                        <input type="text" value={reservacion.LugarDevolucion.Direccion} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="FECHA Y HORA" />
                                        <input type="text" value={reservacion.FechaDevolucion} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
                {
                    (reservacion.LugarRecepcion !== undefined) &&
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>DÍAS DEL ALQUILER</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="TOTAL" />
                                        <input type="text" value={Dias} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
                {
                    (vehiculo.Id !== undefined) &&
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>DATOS DEL VEHÍCULO</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="TIPO" />
                                        <input type="text" value={vehiculo.Categoria.Nombre} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="VEHÍCULO" />
                                        <input type="text" value={vehiculo.Nombre} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-group mb-2">
                                        <Label name="TRANSMISIÓN" />
                                        <input type="text" value={vehiculo.Transmision.Nombre} readOnly={true} className="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
                {
                    coberturas.some(cob => cob.Seleccionado) && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>COBERTURAS</h5>
                                    </div>
                                </div>
                                {coberturas
                                    .filter(cob => cob.Seleccionado)
                                    .map((cobertura, index) => {
                                        const precioFormateado = cobertura.Precio.toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });
                                        const totalFormateado = (cobertura.Precio * Dias).toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });

                                        return (
                                            <div className="row" key={index}>
                                                <div className="col-md-12">
                                                    <div className="input-group mb-2 coberturasClass">
                                                        <div style={{ width: '80%', paddingRight: '5px' }}>
                                                            <Label 
                                                                name={`${cobertura.Descripcion} (Q ${precioFormateado} × ${Dias})`} 
                                                                style={{ display: 'block!imporant'  }} 
                                                            />
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <input 
                                                                type="text" 
                                                                value={`Q ${totalFormateado}`} 
                                                                readOnly={true} 
                                                                className="form-control" 
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                                <div className="row line-bill-bold">
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        Total Coberturas
                                    </div>
                                    <div className="col-md-6 price-red">
                                        Q {coberturas
                                            .reduce((total, cob) => total + (cob.Seleccionado ? cob.Precio * Dias : 0), 0)
                                            .toLocaleString('en', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {/* Espacio entre secciones */}
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
                {
                    servicios.some(ser => ser.Seleccionado) && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>SERVICIOS</h5>
                                    </div>
                                </div>
                                {servicios
                                    .filter(ser => ser.Seleccionado)
                                    .map((servicio, index) => {
                                        const precioFormateado = servicio.Precio.toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });
                                        const totalFormateado = (servicio.Precio * Dias).toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });

                                        return (
                                            <div className="row" key={index}>
                                                <div className="col-md-12">
                                                    <div className="input-group mb-2 coberturasClass">
                                                        <div style={{ width: '80%', paddingRight: '5px' }}>
                                                            <Label
                                                                name={`${servicio.Descripcion} (Q ${precioFormateado} × ${Dias})`}
                                                                style={{ display: 'block' }} // Sobrescribe el flex
                                                            />
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <input
                                                                type="text"
                                                                value={`Q ${totalFormateado}`}
                                                                readOnly={true}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                                <div className="row line-bill-bold">
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        Total Servicios
                                    </div>
                                    <div className="col-md-6 price-red">
                                        Q {servicios
                                            .reduce((total, ser) => total + (ser.Seleccionado ? ser.Precio * Dias : 0), 0)
                                            .toLocaleString('en', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {/* Espacio entre secciones */}
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
                {
                    fronteras.some(fro => fro.Seleccionado) && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>FRONTERAS</h5>
                                    </div>
                                </div>
                                {fronteras
                                    .filter(fro => fro.Seleccionado)
                                    .map((frontera, index) => {
                                        const precioFormateado = frontera.Precio.toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });
                                        const totalFormateado = (frontera.Precio * Dias).toLocaleString('en', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });
                                        return (
                                            <div className="row" key={index}>
                                                <div className="col-md-12">
                                                    <div className="input-group mb-2 coberturasClass">
                                                        <div style={{ width: '80%', paddingRight: '5px' }}>
                                                            <Label
                                                                name={`${frontera.Descripcion} (Q ${precioFormateado} × ${Dias})`}
                                                                style={{ display: 'block' }} // Sobrescribe el flex
                                                            />
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <input
                                                                type="text"
                                                                value={`Q ${totalFormateado}`}
                                                                readOnly={true}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                                <div className="row line-bill-bold">
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-6">
                                        Total Fronteras
                                    </div>
                                    <div className="col-md-6 price-red">
                                        Q {fronteras
                                            .reduce((total, fro) => total + (fro.Seleccionado ? fro.Precio : 0), 0)
                                            .toLocaleString('en', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    (coberturas.find(w => w.Seleccionado) || servicios.find(w => w.Seleccionado) || fronteras.find(w => w.Seleccionado)) &&
                    <div className="row">
                        <div className="col-md-12">                                            
                            <div className="row ">
                                <div className="col-md-12">
                                    <hr />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    Total GTQ
                                </div>
                                <div className="col-md-6 price-red">
                                    Q {(
                                        ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * Dias, 0) : 0)
                                        + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * Dias, 0) : 0)
                                        + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)
                                    ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    Total USD
                                </div>
                                <div className="col-md-6 price-red">
                                    $ {
                                        ((
                                            ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * Dias, 0) : 0)
                                            + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * Dias, 0) : 0)
                                            + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)
                                        ) / Cambio).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    resetReservacion: () => dispatch(reset()),
    resetDataCliente: () => dispatch(resetForm("FormDataCliente")),
})

export default connect(null, mapDispatchToProps)(Summary);